import { Component, OnInit, ViewChild } from '@angular/core';
import { BlogData, IapData } from './catalogue-iap-page.model';
import { CatalougeDisplayIAPContentComponent } from './catalouge-display-iap-content/catalouge-display-iap-content.component';

@Component({
  selector: 'app-catalogue-iap-page',
  templateUrl: './catalogue-iap-page.component.html',
  styleUrls: ['./catalogue-iap-page.component.scss']
})
export class CatalogueIapPageComponent implements OnInit {
  getSimilarAticles: boolean;

  constructor() { }
  tempIapData = new IapData()
   @ViewChild(CatalougeDisplayIAPContentComponent, { static: false })

  CatalougeDisplayIAPContentComponent!:CatalougeDisplayIAPContentComponent;


  ngOnInit() {
  }

  public onTeamEdit(data: IapData) {
    this.tempIapData ={...data}
  }

  public onArticleDelete(){
    this.getSimilarAticles = true;
  }

  public onRefresh(data) {
    if (this.CatalougeDisplayIAPContentComponent) {
      if(data === 'Banners'){
        this.CatalougeDisplayIAPContentComponent.getBanners();
      }
      else if (data === 'Videos'){
        this.CatalougeDisplayIAPContentComponent.getVideos();
      }
      else if (data === 'Infographics'){
        this.CatalougeDisplayIAPContentComponent.getInfographics();
      }
      else if (data === 'Articles'){
        this.CatalougeDisplayIAPContentComponent.getArticles();
      }
      else if (data === 'Section1' || data === 'Section2' || data === 'Form' || data === 'Section3' || data === 'Disclaimer') {
        this.CatalougeDisplayIAPContentComponent.getText(data)
      }
    } else {
      console.warn('catalougeListTeamMembersComponent is not available');
    }
  }

}
